// Display only: preserve incomplete, masked and non-mobile legacy values.
export function formatStudentContact(value) {
  const original = value == null ? "" : String(value);
  if (!/^[\d\s-]+$/.test(original)) return original;
  const digits = original.replace(/[\s-]/g, "");
  if (digits.length !== 11) return original;
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
}
